import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandH3(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path d="M15.454 8.916V4.791l-3.583-2.043 3.583 6.168Z" fill="url(#h3_a)" />
      <path d="M11.871 2.748 15.454.667l3.622 2.08H11.87Z" fill="url(#h3_b)" />
      <path d="M19.075 2.748v4.087l-3.62 2.081 3.62-6.168Z" fill="url(#h3_c)" />
      <path d="M11.871 2.748v4.087l3.583 2.081-3.583-6.168Z" fill="url(#h3_d)" />
      <path d="M15.454 8.916V4.791l3.621-2.043-3.62 6.168Z" fill="url(#h3_e)" />
      <path d="M19.076 2.748 15.454 4.79l-3.583-2.043h7.205Z" fill="url(#h3_f)" />
      <path d="m19.076 15.084-3.622 2.081-3.583-2.081h7.205Z" fill="url(#h3_g)" />
      <path d="M19.075 15.084v4.125l-3.62 2.08 3.62-6.205Z" fill="url(#h3_h)" />
      <path d="M15.454 21.29v-4.125l3.621-2.081-3.62 6.206Z" fill="url(#h3_i)" />
      <path d="M11.871 15.084v4.125l3.583 2.08-3.583-6.205Z" fill="url(#h3_j)" />
      <path d="M15.454 21.29v-4.125l-3.583-2.081 3.583 6.206Z" fill="url(#h3_k)" />
      <path d="m11.871 15.084 3.583-2.043 3.622 2.043H11.87Z" fill="url(#h3_l)" />
      <path d="m8.25 8.916 3.621-2.081 3.583 2.081H8.25Z" fill="url(#h3_m)" />
      <path d="M15.454 8.916v4.125l-3.583 2.043 3.583-6.168Z" fill="url(#h3_n)" />
      <path d="M11.871 15.084v-4.125L8.25 8.916l3.621 6.168Z" fill="url(#h3_o)" />
      <path d="M8.25 8.916v4.125l3.621 2.043L8.25 8.916Z" fill="url(#h3_p)" />
      <path d="M11.871 15.084v-4.125l3.583-2.043-3.583 6.168Z" fill="url(#h3_q)" />
      <path d="m15.454 8.916-3.583 2.043L8.25 8.916h7.204Z" fill="url(#h3_r)" />
      <path d="m11.871 15.084-3.62 2.081-3.584-2.081h7.204Z" fill="url(#h3_s)" />
      <path d="M4.667 15.084v-4.125L8.25 8.916l-3.583 6.168Z" fill="url(#h3_t)" />
      <path d="m4.667 15.084 3.583-2.043 3.621 2.043H4.667Z" fill="url(#h3_u)" />
      <path d="M8.25 8.916v4.125l-3.583 2.043L8.25 8.916Z" fill="url(#h3_v)" />
      <path d="M11.871 15.084v4.125l-3.621 2.08 3.621-6.205Z" fill="url(#h3_w)" />
      <path d="m15.454 21.29-3.583 2.043L8.25 21.29h7.204Z" fill="url(#h3_x)" />
      <path d="m8.25 21.29 3.621-2.081 3.583 2.08H8.25Z" fill="url(#h3_y)" />
      <path d="M8.25 21.29v-4.125l3.621-2.081L8.25 21.29Z" fill="url(#h3_z)" />
      <defs>
        <linearGradient
          id="h3_a"
          x1="13.661"
          y1="10.916"
          x2="13.661"
          y2="1.269"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
        <linearGradient
          id="h3_b"
          x1="11.863"
          y1="1.698"
          x2="19.059"
          y2="1.698"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_c"
          x1="20.12"
          y1="8.662"
          x2="15.796"
          y2="7.182"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_d"
          x1="13.674"
          y1="9.19"
          x2="13.483"
          y2="2.628"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
        <linearGradient
          id="h3_e"
          x1="17.259"
          y1="10.895"
          x2="17.259"
          y2="3.835"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_f"
          x1="10.923"
          y1="1.892"
          x2="12.68"
          y2="8.334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_g"
          x1="12.073"
          y1="14.267"
          x2="13.038"
          y2="18.425"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".453" stopColor="#5F943D" />
          <stop offset="1" stopColor="#AFD475" />
        </linearGradient>
        <linearGradient
          id="h3_h"
          x1="20.121"
          y1="21.035"
          x2="15.797"
          y2="19.574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
        <linearGradient
          id="h3_i"
          x1="17.259"
          y1="23.268"
          x2="17.259"
          y2="16.208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
        <linearGradient
          id="h3_j"
          x1="10.232"
          y1="14.972"
          x2="18.981"
          y2="18.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_k"
          x1="8.79"
          y1="14.964"
          x2="18.935"
          y2="17.125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_l"
          x1="10.022"
          y1="13.947"
          x2="18.056"
          y2="17.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".453" stopColor="#5F943D" />
          <stop offset="1" stopColor="#AFD475" />
        </linearGradient>
        <linearGradient
          id="h3_m"
          x1="8.265"
          y1="7.884"
          x2="15.46"
          y2="7.884"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_n"
          x1="16.522"
          y1="14.848"
          x2="12.201"
          y2="13.401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_o"
          x1="10.064"
          y1="17.104"
          x2="10.064"
          y2="7.454"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
        <linearGradient
          id="h3_p"
          x1="10.064"
          y1="14.38"
          x2="10.064"
          y2="6.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
        <linearGradient
          id="h3_q"
          x1="13.661"
          y1="17.082"
          x2="13.661"
          y2="10.021"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_r"
          x1="7.101"
          y1="8.386"
          x2="9.294"
          y2="14.872"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_s"
          x1="2.297"
          y1="15.467"
          x2="8.836"
          y2="22.185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_t"
          x1="6.466"
          y1="17.082"
          x2="6.466"
          y2="10.021"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_u"
          x1="4.667"
          y1="14.071"
          x2="11.863"
          y2="14.071"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE700" />
          <stop offset=".018" stopColor="#FFE401" />
          <stop offset=".344" stopColor="#F8A912" />
          <stop offset=".623" stopColor="#F47E1E" />
          <stop offset=".841" stopColor="#F16425" />
          <stop offset=".969" stopColor="#F05A28" />
        </linearGradient>
        <linearGradient
          id="h3_v"
          x1="9.327"
          y1="14.848"
          x2="5.006"
          y2="13.401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_w"
          x1="10.064"
          y1="20.979"
          x2="10.064"
          y2="14.369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
        <linearGradient
          id="h3_x"
          x1="7.105"
          y1="18.597"
          x2="7.895"
          y2="24.171"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_y"
          x1="15.585"
          y1="19.143"
          x2="14.763"
          y2="24.824"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DAC" />
          <stop offset="1" stopColor="#3AC3DF" />
        </linearGradient>
        <linearGradient
          id="h3_z"
          x1="11.632"
          y1="19.752"
          x2="6.567"
          y2="18.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4007E" />
          <stop offset="1" stopColor="#471267" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
